/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：364
 */

"use strict"

var r = require(/* 1190 */"./1190")
exports.a = function (e, t, n) {
  r.a(e, "[antd: ".concat(t, "] ").concat(n))
}
